$('.video .play').on('click', function () {
    $(this).parents('.video').find('#ytplayer').attr('src', function () {
        return $(this).attr('src') + '&autoplay=1';
    });
    $(this).remove();
});
